import { render } from "./InquiryList.vue?vue&type=template&id=f4f7733c"
import script from "./InquiryList.vue?vue&type=script&lang=js"
export * from "./InquiryList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__